// What is specific to the trado audit (the mobil one is in audit-kendaraan-mobil-editor/utils).
const tradoAuditEditorConfig = {
  // title of the page
  baseTitle: "Audit Trado",

  // a trailer is needed when there is no kendaraan, and the trailer field is shown next to the kendaraan
  requireTrailer: true,
  showTrailerField: true,

  // which kendaraan can be picked in the header
  kendaraanSelectorFilter: "data_kendaraan_jenis.nama:=:Trado",
};

export default tradoAuditEditorConfig;
